'use client'

import dynamic from 'next/dynamic'
import Link from 'next/link'
import { ROUTES } from '@/constants/routes'
import { useI18n } from '@/components/i18n-provider'
import { HeaderNavSkeleton } from '@/components/header-nav-skeleton'

const HeaderNav = dynamic(
  () => import('@/components/header-nav').then((m) => ({ default: m.HeaderNav })),
  {
    loading: () => <HeaderNavSkeleton />,
    ssr: false,
  }
)

export function Header() {
  const { t, locale } = useI18n()

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
        <Link href={ROUTES.HOME(locale)} className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
            <span className="text-sm font-bold text-primary-foreground">PM</span>
          </div>
          <span className="text-lg font-semibold text-foreground">
            {t('header.siteName')}
          </span>
        </Link>

        <div className="flex items-center gap-4">
          <HeaderNav />
        </div>
      </div>
    </header>
  )
}
